import styled from 'styled-components';

export const Container = styled.div`
  padding: 3rem 2rem 2rem 2rem;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};

  h5 {
    margin: 0;
  }

  & > div.details {
    width: 70%;

    & > div:not(:last-child) {
      padding-bottom: 1rem;
    }
  }

  & > div.values {
    width: 30%;

    & > div:not(:last-child) {
      padding-bottom: 1rem;
    }
  }
`;

export const Row = styled.div`
  display: flex;

  & > div {
    padding-right: 4rem;
  }
`;

export const WarningText = styled.div`
  padding-top: 0.5rem;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
